import axios from "axios";
import Loading from "vue-loading-overlay";
export default {
    name: "WinnerList",
    components:{Loading},
    data() {
        return {
            isLoading: true,
            fullPage: true,
            loader: "bars",
            date: undefined,
            realDate: undefined,
            winnerList:[],
            realWinnerList:[]
        }
    },
    async created() {
        await this.getAll();
        await this.getRealAll();
    },
    methods: {
        async getAll() {
            const token = localStorage.getItem(this.$tokenKey);
            const startDate = this.$filters.formatDateTM(new Date());
            const endDate = this.$filters.formatDateTM(new Date());
            try {
                const res = await axios.get(
                    this.$baseUrl +
                    this.$api +
                    this.$version3 +
                    "/quiz/getAdminLeaderboard?startDate=" + startDate +"&endDate=" + endDate,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json"
                        },
                    }
                );
                this.isLoading = false;
                if (res.status === 200) {
                    this.winnerList = res.data.data
                    this.isLoading = false;
                } else {
                    this.$vToastify.error("Could not fetch data!");
                }
            } catch (error) {
                console.log(error);
                this.isLoading = false;
            }
        },
        async getRealAll() {
            const token = localStorage.getItem(this.$tokenKey);
            const startDate = this.$filters.formatDateTM(new Date());
            const endDate = this.$filters.formatDateTM(new Date());
            try {
                const res = await axios.get(
                    this.$baseUrl +
                    this.$api +
                    this.$version3 +
                    "/quiz/adminGetLeaderboardFiltered?startDate=" + startDate +"&endDate=" + endDate,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json"
                        },
                    }
                );
                this.isLoading = false;
                if (res.status === 200) {
                    console.log("kkk==", res.data.data)
                    this.realWinnerList = res.data.data
                    console.log("this.realWinnerList==", this.realWinnerList)
                    this.isLoading = false;
                } else {
                    this.$vToastify.error("Could not fetch data!");
                }
            } catch (error) {
                console.log(error);
                this.isLoading = false;
            }
        },
        async filterByDate() {
            this.isLoading = true;
            const token = localStorage.getItem(this.$tokenKey);
            const startDate = this.date;
            const endDate = this.date;
            try {
                const res = await axios.get(
                    this.$baseUrl +
                    this.$api +
                    this.$version3 +
                    "/quiz/getAdminLeaderboard?startDate=" + startDate +"&endDate=" + endDate,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json"
                        },
                    }
                );
                this.isLoading = false;
                if (res.status === 200) {
                    this.winnerList = res.data.data
                    this.isLoading = false;
                } else {
                    this.$vToastify.error("Could not fetch data!");
                }
            } catch (error) {
                console.log(error);
                this.isLoading = false;
            }
        },
        async filterByDateReal() {
            this.isLoading = true;
            const token = localStorage.getItem(this.$tokenKey);
            const startDate = this.realDate;
            const endDate = this.realDate;
            try {
                const res = await axios.get(
                    this.$baseUrl +
                    this.$api +
                    this.$version3 +
                    "/quiz/adminGetLeaderboardFiltered?startDate=" + startDate +"&endDate=" + endDate,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json"
                        },
                    }
                );
                this.isLoading = false;
                if (res.status === 200) {
                    this.realWinnerList = res.data.data
                    this.isLoading = false;
                } else {
                    this.$vToastify.error("Could not fetch data!");
                }
            } catch (error) {
                console.log(error);
                this.isLoading = false;
            }
        },
    }
}
